import AlarmsAnalytics from './container'

export default AlarmsAnalytics
